import EventHandler from '../../utils/dom/event-handler';
import SelectorEngine from '../../utils/dom/selector-engine';
import Request, { ApiMode } from '../../utils/Request';
import RadioComponent from '../RadioComponent';
import BaseComponent from '../BaseComponent';
import { OVERLAY_MODAL_OPEN_EVENT } from '../../webComponents/OverlayModal';

const NAME = 'EarlyYearsContentModal';
const SELECTOR_NURSERY_QUESTION = '.js-school-portal-nursery-question';
const SELECTOR_CONFIRM_BUTTON = '.js-school-portal-early-access-modal-confirm';

const CLICK_EVENT = 'click';
const SAVE_NURSERY_PREFERENCE_URL = '/api/teachermembership/SaveTeacherOnboardingDetails';
const IS_LOCAL = false;

export class EarlyYearsContentModal extends BaseComponent {
	static get NAME() {
		return NAME;
	}

	constructor(element) {
		super(element);
		if (!this._element) return;

		this.modal = this._element;

		if (!this.modal) {
			return;
		}
		
		this.onModalOpen = this.onModalOpen.bind(this);
		this.modal.addEventListener(OVERLAY_MODAL_OPEN_EVENT, this.onModalOpen);
		
		this.initNurseryQuestion();
	}

	initNurseryQuestion() {
		

		this.confirmButton = SelectorEngine.findOne(SELECTOR_CONFIRM_BUTTON, this._element);
		
		// Reset confirm button state
		this.confirmButton.disabled = true;

		// Add event listener to confirm button
		this.onConfirmClick = this.onConfirmClick.bind(this);
		EventHandler.on(this.confirmButton, CLICK_EVENT, this.onConfirmClick);

		
		if (this.nurseryRadioComponent) {
			this.resetNurserySelection();
		}

		const nurseryQuestionContainer = SelectorEngine.findOne(SELECTOR_NURSERY_QUESTION, this._element);
		if (!nurseryQuestionContainer) {
			this.modal.isOpen = false;
			return;
		}

		this.nurseryRadioComponent = new RadioComponent(nurseryQuestionContainer, {
			data: {
				id: 'school-portal-nursery',
				fieldName: 'hasNursery',
				questionPrefix: 'Does your school',
				question: 'Have a nursery or would you like to see early years content?',
				errorMessage: 'Please select an option to proceed',
				options: [
					{ id: 0, label: 'Yes' },
					{ id: 1, label: 'No' }
				]
			}
		});

		this.nurseryRadioComponent.onChange(() => {
			this.confirmButton.disabled = false;
		});
	}

	onModalOpen() {
		this.initNurseryQuestion();
	}

	resetNurserySelection() {
		this.nurseryRadioComponent.remove();
	}

	async onConfirmClick(event) {
		event.preventDefault();

		if (!this.nurseryRadioComponent?.validate()) {
			return;
		}

		const nurseryAnswer = this.nurseryRadioComponent.value;
		const payload = {
			[nurseryAnswer.fieldName]: nurseryAnswer.value
		};

		this.confirmButton.disabled = true;

		try {
			const response = await Request.post(SAVE_NURSERY_PREFERENCE_URL, payload, {
				local: IS_LOCAL,
				req: {
					apiMode: ApiMode.LtaError
				}
			});
			const { Success, error } = response;

			if (Success) {
				this.resetNurserySelection();
				this.modal.isOpen = false;
				return;
			}

			if (error?.hasError) {
				throw error;
			}
		} catch (error) {
			if (error?.hasError) {
				console.log('Error:', error);
			}
		}

		this.confirmButton.disabled = false;
	}
}

export default EarlyYearsContentModal;
